import {
  GET_OVERVIEW_TABLE_DATA,
  SET_SEARCH_DATA,
  SET_SELECTED_DATA,
  SET_LOCK_TO_DO_FILTER,
  CLEAR_SEARCH,
  RESET_REDUX_STATE,
  GET_OVERVIEW_SUMMARY_COUNT,
  GET_OVERVIEW_CARD_DETAILS,
  SET_USER_TYPE_FILTER,
  SET_USER_FILTER,
  SET_TODO_FILTER,
  GROUPED_BY_FILTER,
  GET_SINGLE_CARD_DETAILS,
  SET_DATE_RANGE,
  SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN
} from "../constants";
import moment from "moment";

const initialValue = {
  overviewData: [],
  selected: [2,3,4,5],
  searchText: undefined,
  lockToDoFilter: false,
  overviewSummaryCount: {},
  overviewCardData: [],
  userTypeFilter: {
    label: "@Me",
    value: "Me",
  },
  userFilter: undefined,
  todoFilter: undefined,
  groupedByFilter: false,
  overviewSingleCard: [],
  dateRange: {
    start_date: moment().clone().startOf('month').format('YYYY-MM-DD'),
    end_date: moment().clone().endOf('month').format('YYYY-MM-DD')
  },
  overviewNotificationData: []
};

const overview = (state = initialValue, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_OVERVIEW_TABLE_DATA: {
      return {
        ...state,
        overviewData: payload,
      };
    }

    case SET_SEARCH_DATA: {
      return {
        ...state,
        searchText: payload,
      };
    }

    case SET_SELECTED_DATA: {
      return {
        ...state,
        selected: payload,
      };
    }

    case SET_LOCK_TO_DO_FILTER: {
      return {
        ...state,
        lockToDoFilter: payload,
      };
    }

    case SET_USER_TYPE_FILTER: {
      return {
        ...state,
        userTypeFilter: payload
      }
    }

    case SET_USER_FILTER: {
      return {
        ...state,
        userFilter: payload
      }
    }

    case SET_TODO_FILTER: {
      return {
        ...state,
        todoFilter: payload
      }
    }

    case GROUPED_BY_FILTER: {
      return {
        ...state,
        groupedByFilter: payload
      }
    }

    case CLEAR_SEARCH: {
      return {
        ...state,
        searchText: undefined,
      };
    }

    case GET_OVERVIEW_SUMMARY_COUNT: {
      return {
        ...state,
        overviewSummaryCount: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initialValue;
    }

    case GET_OVERVIEW_CARD_DETAILS: {
      return {
        ...state,
        overviewCardData: payload
      }
    }

    case GET_SINGLE_CARD_DETAILS: {
      return {
        ...state,
        overviewSingleCard: payload
      }
    }

    case SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: payload
      }
    }

    case SET_NOTIFICATION_DATA_FOR_OVERVIEW_SCREEN: {
      return {
        ...state,
        overviewNotificationData: payload
      }
    }

    default:
      return state;
  }
};

export default overview;
